import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import HorizontalTestimonial from "./horizontal-testimonial";

const TestimonialsList = () => {
  const data = useStaticQuery(graphql`
    query {
      kolos: file(relativePath: { eq: "testimonials/Kolos-Tapler.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      pier1: file(relativePath: { eq: "testimonials/pier-1.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      pier2: file(relativePath: { eq: "testimonials/pier-2.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      andy: file(relativePath: { eq: "testimonials/andy-collins.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      catherine: file(
        relativePath: { eq: "testimonials/catherine-clifford.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      louise: file(relativePath: { eq: "testimonials/louise-taylor.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      louis: file(relativePath: { eq: "testimonials/louis-jones.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      tania: file(relativePath: { eq: "testimonials/tania-pieri.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      andrew: file(relativePath: { eq: "testimonials/andrew-durling.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      antoinette: file(
        relativePath: { eq: "testimonials/antoinette-chappell.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      aryajit: file(relativePath: { eq: "testimonials/aryajit-heppell.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      cale: file(relativePath: { eq: "testimonials/cale-sinfield.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      daniel: file(relativePath: { eq: "testimonials/daniel-brookbank.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      helen: file(relativePath: { eq: "testimonials/helen-burton.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      james: file(relativePath: { eq: "testimonials/james-gasson.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      jon: file(relativePath: { eq: "testimonials/jon-shortell.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      kevin: file(relativePath: { eq: "testimonials/kevin-hinton.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      liz: file(relativePath: { eq: "testimonials/liz-george.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      rhys: file(relativePath: { eq: "testimonials/rhys-watford.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      sarah: file(relativePath: { eq: "testimonials/sarah-bennett.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      emma: file(relativePath: { eq: "testimonials/Emma-Pearce.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      russ: file(relativePath: { eq: "testimonials/Russ-Deacon.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      lisa: file(relativePath: { eq: "testimonials/Lisa-Sarsons.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      darrell: file(relativePath: { eq: "testimonials/Darrell-Deeprose.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      jordan: file(relativePath: { eq: "testimonials/Jordan-Hay-Ellis.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      tristan: file(relativePath: { eq: "testimonials/Tristan-Bund.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      alan: file(relativePath: { eq: "testimonials/Alan-Norton.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      margaret: file(
        relativePath: { eq: "testimonials/Margaret-Sinclair.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      andrea: file(relativePath: { eq: "testimonials/Andrea-Birch.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      clare: file(relativePath: { eq: "testimonials/Clare-Payne.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      moxy: file(relativePath: { eq: "testimonials/Moxy-Child.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      greg: file(relativePath: { eq: "testimonials/Greg-Draven.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      jane: file(relativePath: { eq: "testimonials/Jane-Long.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      elena: file(relativePath: { eq: "testimonials/Elena-Cornes.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      richard: file(relativePath: { eq: "testimonials/Richard-Smith.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      lee: file(relativePath: { eq: "testimonials/Lee-Courtney.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      susan: file(relativePath: { eq: "testimonials/Susan-Beckingham.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      robbie: file(relativePath: { eq: "testimonials/robbie-mould.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      danielle: file(relativePath: { eq: "testimonials/danielle-lloyd.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      liam: file(relativePath: { eq: "testimonials/liam-atkins.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      miles: file(relativePath: { eq: "testimonials/miles-hall.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      nick: file(relativePath: { eq: "testimonials/nick-bryant.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      shaun: file(relativePath: { eq: "testimonials/shaun-stevens.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      luke: file(relativePath: { eq: "testimonials/luke-watts.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      dHill: file(relativePath: { eq: "testimonials/Peter Hill.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      silvia: file(relativePath: { eq: "testimonials/silvia-hartmann.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      claire: file(relativePath: { eq: "testimonials/claire-white.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      chris: file(relativePath: { eq: "testimonials/chris-novis.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      mariia: file(relativePath: { eq: "testimonials/mariia-savvinova.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      jannine: file(relativePath: { eq: "testimonials/jannine-howe.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      davidS: file(relativePath: { eq: "testimonials/david_sinclair.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      MikeS: file(relativePath: { eq: "testimonials/Mike-Sherwood.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      selda: file(relativePath: { eq: "testimonials/selda-koydemir.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      carolineS: file(relativePath: { eq: "testimonials/caroline-somer.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      stuart: file(
        relativePath: { eq: "testimonials/profile_stuart_long.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      gregS: file(relativePath: { eq: "testimonials/Greg-Stevenson.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      jessC: file(relativePath: { eq: "testimonials/Jessica Cox.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      andrewF: file(relativePath: { eq: "testimonials/Andrew-Fenton.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      debG: file(relativePath: { eq: "testimonials/Debbie greenwood.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      lou: file(relativePath: { eq: "testimonials/lou.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      chrisP: file(relativePath: { eq: "testimonials/Christian-Parker.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      pierreB: file(relativePath: { eq: "testimonials/Pierre Bauzee.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      matt: file(relativePath: { eq: "testimonials/Matt Cranfield IT.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      claireF: file(
        relativePath: { eq: "testimonials/Claire freemen New.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      harryW: file(relativePath: { eq: "testimonials/Harry Whale.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      giuseppe: file(relativePath: { eq: "testimonials/giuseppe.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      richardW: file(
        relativePath: { eq: "testimonials/Richard Worsfold.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      victoriaR: file(
        relativePath: { eq: "testimonials/Vicki-Integrity.jpeg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      aliceS: file(relativePath: { eq: "testimonials/Dr-Alice-Scott.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      sylviaA: file(
        relativePath: { eq: "testimonials/Sylvia Maths Teacher.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      FrancineW: file(
        relativePath: { eq: "testimonials/Frankie-Widdows-1.png" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      laurenceK: file(relativePath: { eq: "testimonials/Laurence Katz.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      benG: file(relativePath: { eq: "testimonials/Ben Gottlieb.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      carolS: file(relativePath: { eq: "testimonials/Carol Seaborne.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      francesT: file(relativePath: { eq: "testimonials/Frances Thapen.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      IngaK: file(relativePath: { eq: "testimonials/Inga kopala.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      mattG: file(relativePath: { eq: "testimonials/MatthewGiles.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      StuartG: file(relativePath: { eq: "testimonials/Stuart Gardiner.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      ElizabethK: file(relativePath: { eq: "testimonials/ElizabethK.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      KarlF: file(relativePath: { eq: "testimonials/KarlF.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      MartynB: file(relativePath: { eq: "testimonials/Martyn Beaumont.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      elizabethK: file(
        relativePath: { eq: "testimonials/elizabeth-keates.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      markrawlings: file(
        relativePath: { eq: "testimonials/mark-rawlings.jpeg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      calesinfield: file(
        relativePath: { eq: "testimonials/cale-sinfield.jpeg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      johndonegan: file(
        relativePath: { eq: "testimonials/john-donegan.jpeg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      billy: file(relativePath: { eq: "testimonials/Billy-Cook.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      ellizabath: file(relativePath: { eq: "testimonials/ellizabath.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      heba: file(relativePath: { eq: "testimonials/Heba-Ghazi.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      richardNew: file(relativePath: { eq: "testimonials/richard.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      beng: file(relativePath: { eq: "testimonials/beng.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      tedw: file(relativePath: { eq: "testimonials/tedw.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      lisaw: file(relativePath: { eq: "testimonials/lisa-sharren.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      mark: file(relativePath: { eq: "testimonials/mark-wiffen.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      katja: file(relativePath: { eq: "testimonials/katja-kamsek.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      nila: file(relativePath: { eq: "testimonials/nila-salari.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      benjamin: file(relativePath: { eq: "testimonials/benjamin.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      naomi: file(relativePath: { eq: "testimonials/naomi.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      amarel: file(relativePath: { eq: "testimonials/amar-el.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
    }
  `);
  const ElizabethK = data.ElizabethK.childImageSharp.gatsbyImageData;
  const MartynB = data.MartynB.childImageSharp.gatsbyImageData;
  const KarlF = data.KarlF.childImageSharp.gatsbyImageData;
  const StuartG = data.StuartG.childImageSharp.gatsbyImageData;
  const kolos = data.kolos.childImageSharp.gatsbyImageData;
  const mattG = data.mattG.childImageSharp.gatsbyImageData;
  const IngaK = data.IngaK.childImageSharp.gatsbyImageData;
  const benG = data.benG.childImageSharp.gatsbyImageData;
  const francesT = data.francesT.childImageSharp.gatsbyImageData;
  const carolS = data.carolS.childImageSharp.gatsbyImageData;
  const laurenceK = data.laurenceK.childImageSharp.gatsbyImageData;
  const FrancineW = data.FrancineW.childImageSharp.gatsbyImageData;
  const sylviaA = data.sylviaA.childImageSharp.gatsbyImageData;
  const victoriaR = data.victoriaR.childImageSharp.gatsbyImageData;
  const claireF = data.claireF.childImageSharp.gatsbyImageData;
  const pier1 = data.pier1.childImageSharp.gatsbyImageData;
  const pier2 = data.pier2.childImageSharp.gatsbyImageData;
  const andy = data.andy.childImageSharp.gatsbyImageData;
  const MikeS = data.MikeS.childImageSharp.gatsbyImageData;
  const davidS = data.davidS.childImageSharp.gatsbyImageData;
  const catherine = data.catherine.childImageSharp.gatsbyImageData;
  const louise = data.louise.childImageSharp.gatsbyImageData;
  const louis = data.louis.childImageSharp.gatsbyImageData;
  const tania = data.tania.childImageSharp.gatsbyImageData;
  const andrew = data.andrew.childImageSharp.gatsbyImageData;
  const antoinette = data.antoinette.childImageSharp.gatsbyImageData;
  const aryajit = data.aryajit.childImageSharp.gatsbyImageData;
  const cale = data.cale.childImageSharp.gatsbyImageData;
  const daniel = data.daniel.childImageSharp.gatsbyImageData;
  const helen = data.helen.childImageSharp.gatsbyImageData;
  const james = data.james.childImageSharp.gatsbyImageData;
  const jon = data.jon.childImageSharp.gatsbyImageData;
  const kevin = data.kevin.childImageSharp.gatsbyImageData;
  const liz = data.liz.childImageSharp.gatsbyImageData;
  const rhys = data.rhys.childImageSharp.gatsbyImageData;
  const sarah = data.sarah.childImageSharp.gatsbyImageData;
  const selda = data.selda.childImageSharp.gatsbyImageData;
  const emma = data.emma.childImageSharp.gatsbyImageData;
  const russ = data.russ.childImageSharp.gatsbyImageData;
  const lisa = data.lisa.childImageSharp.gatsbyImageData;
  const darrell = data.darrell.childImageSharp.gatsbyImageData;
  const jordan = data.jordan.childImageSharp.gatsbyImageData;
  const tristan = data.tristan.childImageSharp.gatsbyImageData;
  const alan = data.alan.childImageSharp.gatsbyImageData;
  const margaret = data.margaret.childImageSharp.gatsbyImageData;
  const andrea = data.andrea.childImageSharp.gatsbyImageData;
  const clare = data.clare.childImageSharp.gatsbyImageData;
  const moxy = data.moxy.childImageSharp.gatsbyImageData;
  const greg = data.greg.childImageSharp.gatsbyImageData;
  const jane = data.jane.childImageSharp.gatsbyImageData;
  const elena = data.elena.childImageSharp.gatsbyImageData;
  const richard = data.richard.childImageSharp.gatsbyImageData;
  const lee = data.lee.childImageSharp.gatsbyImageData;
  const susan = data.susan.childImageSharp.gatsbyImageData;
  const robbie = data.robbie.childImageSharp.gatsbyImageData;
  const danielle = data.danielle.childImageSharp.gatsbyImageData;
  const liam = data.liam.childImageSharp.gatsbyImageData;
  const miles = data.miles.childImageSharp.gatsbyImageData;
  const nick = data.nick.childImageSharp.gatsbyImageData;
  const shaun = data.shaun.childImageSharp.gatsbyImageData;
  const luke = data.luke.childImageSharp.gatsbyImageData;
  const dHill = data.dHill.childImageSharp.gatsbyImageData;
  const silvia = data.silvia.childImageSharp.gatsbyImageData;
  const claire = data.claire.childImageSharp.gatsbyImageData;
  const chris = data.chris.childImageSharp.gatsbyImageData;
  const mariia = data.mariia.childImageSharp.gatsbyImageData;
  const jannine = data.jannine.childImageSharp.gatsbyImageData;
  const carolineS = data.carolineS.childImageSharp.gatsbyImageData;
  const stuart = data.stuart.childImageSharp.gatsbyImageData;
  const gregS = data.gregS.childImageSharp.gatsbyImageData;
  const jessC = data.jessC.childImageSharp.gatsbyImageData;
  const andrewF = data.andrewF.childImageSharp.gatsbyImageData;
  const elizabethK = data.elizabethK.childImageSharp.gatsbyImageData;
  const debG = data.debG.childImageSharp.gatsbyImageData;
  const lou = data.lou.childImageSharp.gatsbyImageData;
  const chrisP = data.chrisP.childImageSharp.gatsbyImageData;
  const pierreB = data.pierreB.childImageSharp.gatsbyImageData;
  const matt = data.matt.childImageSharp.gatsbyImageData;
  const harryW = data.harryW.childImageSharp.gatsbyImageData;
  const giuseppe = data.giuseppe.childImageSharp.gatsbyImageData;
  const richardW = data.richardW.childImageSharp.gatsbyImageData;
  const aliceS = data.aliceS.childImageSharp.gatsbyImageData;
  const markrawlings = data.markrawlings.childImageSharp.gatsbyImageData;
  const calesinfield = data.calesinfield.childImageSharp.gatsbyImageData;
  const johndonegan = data.johndonegan.childImageSharp.gatsbyImageData;
  const billy = data.billy.childImageSharp.gatsbyImageData;
  const heba = data.heba.childImageSharp.gatsbyImageData;
  const ellizabath = data.ellizabath.childImageSharp.gatsbyImageData;
  const richardNew = data.richardNew.childImageSharp.gatsbyImageData;
  const beng = data.beng.childImageSharp.gatsbyImageData;
  const tedw = data.tedw.childImageSharp.gatsbyImageData;
  const lisaw = data.lisaw.childImageSharp.gatsbyImageData;
  const mark = data.mark.childImageSharp.gatsbyImageData;
  const katja = data.katja.childImageSharp.gatsbyImageData;
  const nila = data.nila.childImageSharp.gatsbyImageData;
  const benjamin = data.benjamin.childImageSharp.gatsbyImageData;
  const naomi = data.naomi.childImageSharp.gatsbyImageData;
  const amarel = data.amarel.childImageSharp.gatsbyImageData;

  const testimonialsList = [
    {
      linkedIn: "https://www.linkedin.com/in/dr-alice-scott-45b268118/",
      profilePic: aliceS,
      id: 74,
      name: "Dr Alice Scott. General Practitioner and Menopause Specialist. Essex Private Doctors.",
      review:
        "Having launched my business, the enormity of the ongoing management, growth and business development felt overwhelming. Starting coaching with Jason is the best business decision I have made so far. His calm, methodical and analytical approach has been invaluable. Sometimes it is easy to get caught up in a situation yourself, making you prone to emotional decision making, and I have found that Jason has been a good sounding board. He is encouraging to help you to push on with what your ultimate goals are. I am still having regular business coaching with Jason.",
    },
    {
      linkedIn: "https://www.linkedin.com/company/heba-ghazi-designs/",
      id: 98,
      name: "Heba Ghazi. Heba Ghazi Designs Ltd",
      profilePic: heba,
      review:
        "Working with Jason has been an incredibly valuable experience. The impact he’s had on how I see myself and my business has been remarkable. I initially expected to focus on fixing surface level issues, but together we took a much deeper approach. Jason helped me step back, reflect on how I was running things, and most importantly, uncover who I am: my personality traits, my strengths, and what I’m truly passionate about.Before working with Jason, I often felt lost, stuck and unsure whether I was even happy doing what I'm doing. Through his guidance, I gained clarity and perspective. What impressed me most was how he helped me see my strengths in a completely new way. Even transforming the weaknesses I once struggled with into opportunities for growth.This process has been an eye-opener on so many levels, both personally and professionally. I’m deeply grateful for the insights and confidence I’ve gained and I look forward to continuing to work with Jason. If you’re looking for a coach who goes beyond quick fixes and helps you grow from the inside out, I can’t recommend Jason enough!",
    },
    {
      linkedIn: "https://www.linkedin.com/in/ben-gottlieb-038a8550",
      id: 1006,
      name: "Ben Gottlieb. Gottlieb Law PLC",
      profilePic: beng,
      review:
        "Jason is an outstanding business coach. He mostly coaches businesses in the UK but also extends virtual coaching services to US businesses. He provides clear headed advice and incorporates business psychology into his coaching. He wants the best for his students. Highly recommended.",
    },
    {
      linkedIn: "https://www.linkedin.com/company/matthew-giles-architects/",
      id: 1002,
      name: "Matthew Giles Architects London",
      profilePic: mattG, // same photo as previous Matt testimonial
      review:
        "Jason is an amazing and talented business coach. I LOVE working with him. I would also be very happy to talk to anyone who is considering working with him. The best.",
    },
    {
      linkedIn:
        "https://www.linkedin.com/in/claire-freeman-frcpods-consultant/",
      profilePic: claireF,
      id: 69,
      name: "Claire Freeman. Consultant Podiatric Surgeon FRCPodS",
      review:
        "How do you choose a business coach? When you know you are stuck, and need help, how do you know who to trust with something as personal and critical as your business? I did a lot of searching and spoke to many different coaches, but when I spoke to Jason I immediately recognised his skill and professionalism. His background, experience and positive attitude have helped me in ways I did not expect. I've learnt so much about myself, the way I run my business and how to effect change. Would I choose him again - absolutely, would I recommend him - absolutely, is my business better off - absolutely, am I still stuck...no.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/katja-%C5%BEibert-kam%C5%A1ek-8956964/",
      profilePic: katja,
      id: 1100,
      name: "Katja Kamsek. International Higher Education Consultant",
      review:
        "Working with Jason has been a truly transformative experience.\n\nThrough his coaching, I uncovered deep, hidden beliefs that had been holding me back, and he supported me powerfully in reflecting on them and developing new, more empowering ones. Jason helped me structure the process of building my business in a way that aligned with my strengths, personal needs, and my own pace smartly and effectively.\n\nI deeply appreciate the breadth and depth of Jason’s business knowledge and experience, as well as his authentic, encouraging, and empowering approach to coaching. Whenever unexpected challenges arose between sessions, he was quick to offer support and made time for us to meet on short notice.\n\nThanks to Jason, I’ve taken on highly challenging actions and built trust in my next steps, steps that I might have spent decades trying to figure out by myself.\n\nI strongly recommend working with Jason if you're looking to build your business wisely.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/nila-salari-b22466299/",
      profilePic: nila,
      id: 1101,
      name: "Nila Salari. Commercial Photographer",
      review:
        "Jason has been an incredible coach in helping me get started with my business. When I first arrived in London, I didn’t know where to begin and felt stuck in moving forward. Working with Jason helped me unravel the areas where I felt blocked and gave me clarity and direction.\n\nI now feel much more confident and reassured about the path I’m taking and creating. On top of that, Jason identified key traits in my personality that made me realise I had far more potential in other areas of my career, opportunities I am now actively pursuing.\n\nIf anyone is looking to expand their business and take things seriously in order to move forward, I highly recommend coaching with Jason!",
    },
    {
      linkedIn: "https://www.linkedin.com/in/amr-el-sayed-46a7024/",
      profilePic: amarel,
      name: "Amr El Sayed. Head of Procurement. Interconnector Ltd",
      review:
        "Jason has been an exceptional coach, and my experience working with him has been genuinely life changing. Although he is known as a business coach, he supported me far beyond the professional side.\n\nOne of the most valuable parts of our work together was exploring my character type using the Myers–Briggs framework. Jason helped me understand my personality, communicate better, and approach workplace challenges with greater self-awareness.\n\nHis style is warm, patient, and highly perceptive. Thanks to him, I’ve developed healthier ways of managing workplace pressures.\n\nI would recommend Jason to anyone seeking personal growth, clarity, and deeper self-understanding.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/benkrich/",
      profilePic: benjamin,
      name: "Benjamin Richardson. Performance Nutritionist",
      review:
        "There is a big difference between working in your business and working on your business.\n\nJason helps you make decisions clearly and also helps you recognise which decisions actually matter. He combines this with warmth and thoughtful challenge.\n\nWorking with him is both a pleasure and a powerful enabler.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/naomi-stonier/",
      profilePic: naomi,
      name: "Naomi Stonier. Relationship Coach",
      review:
        "Jason has been very helpful to me in my business. His advice is straightforward, practical, and easy to follow. He cuts through overwhelm quickly and gets to the key points with calm, kindness, and clarity.\n\nI’m very pleased to have him in my corner.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/lisasheerinspeakproud/",
      id: 1000,
      name: "Lisa Sheerin PCC. Speak Proud. Executive Voice Coach",
      profilePic: lisaw,
      review:
        "Jason has completely opened my eyes to what it really means to run and grow a successful business. Over the past six months, his business insight has been invaluable, but even more impactful has been the shift in mindset he’s helped me cultivate. He’s held up a mirror to my blind spots, challenged how I see myself and changed how I think about people, business, and wealth. It’s been a deep, lasting transformation not just professionally, but personally too.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/elizabeth-keates-film-photography/",
      id: 1001,
      name: "Elizabeth Keates Film and Photography",
      profilePic: ellizabath,
      review:
        "Jason…I have completed my accounts, thanks to your guidance, my business turnover has increased by a staggering 67%. That is HUGE!!! What I value most is your unique ability to be fiercely direct while remaining incredibly supportive and polite. You challenged my assumptions, provided actionable steps, and gave me the confidence to execute. You didn't just give advice; you gave me a system for growth. I also love that I see your other client’s growth and that two of my referrals to you are both incredibly happy but also have similar results. I am super happy to chat to anyone about the way Jason works.",
    },
   
    {
      linkedIn: "https://www.linkedin.com/in/ted-white-65119460/",
      id: 1003,
      name: "Ted White. Music Producer. SODA-SOUND",
      profilePic: tedw,
      review:
        "Working with Jason has been incredible. He helped us grow our businesses while giving us the clarity and confidence we needed to move forward. Truly a great coach!",
    },
    {
      linkedIn: "https://www.linkedin.com/in/richardcohn/",
      id: 1004,
      name: "Richard Cohn. Scribbles Media. Verbal Branding Consultants",
      profilePic: richardNew,
      review:
        "To my mind business coaches fall into two clear categories, those who have studied to be coaches, and those who have the valuable lived business experience to share through coaching. Jason definitely falls into the latter category. I've known a number of people who have asked for his help and their feedback has been uniformly positive as Jason has helped them through the sticking points in their businesses and helped them to move forward with greater certainty and success. And this is the sort of accolade that should be shared, hence my thoughts here.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/mark-wiffen-3244a427/",
      id: 1005,
      name: "Mark Wiffen. Marlin Architectural Design Ltd",
      profilePic: mark,
      review:
        "I have been working with Jason since the beginning of 2021 and in that time have started outsourcing certain areas of my work as a direct result of Jason's encouragement and guidance. This is now enabling me to bring forward my life-long plan of reducing my working week to 4 days to the beginning of 2022, whereas previously it would have been April 2023. Jason has a knack of subtly pushing you further than you feel you want to go. This is enabling me to drive the business forward taking on more work to improve profits at the same time as reducing my hours. Anyone needing business advice would benefit to the better for their sessions with Jason.",
    },
    
    
    {
      linkedIn: "https://www.linkedin.com/in/billymcook/",
      id: 97,
      name: "Billy Cook. Scriptmaster International",
      profilePic: billy,
      review:
        "Jason is wonderful blend of both an immensely calming presence and pragmatic no-nonsense business sense. If you’re like me and your mind is a maelstrom of ideas and wrestling questions, having Jason in your corner will be invaluable for making simpler music from that noise. His guidance quickly oriented me and helped me identify routes to a better financial situation along paths with the lowest hanging fruit – aligned with what I want to do with my life. I had met other coaches before and what has set Jason apart for me is that he is able to mentor as much as a coach. What I mean by this is that “coaching” is fine, but sometimes (often) I don’t want to spend an hour mulling introspective personal explorations and I found that having someone who has been there and done it meant I got to practical, actionable answers, plans and insights far faster than coaching has got for me before. This will be a personality and taste thing - but the good news for you is Jason does both!",
    },
    
    {
      linkedIn: "https://www.linkedin.com/in/mark-rawlings-58bb0a86/",
      id: 53,
      name: "Mark Rawlings. Create Film and Photography",
      profilePic: markrawlings,
      review:
        "I feel like I'm about to review a new piece of camera kit that you can't do without. You must get yourself a Jason. Life changing. Until recently I thought I was a fairly successful cinematographer, shooting and editing films across all genres for high end businesses and personal clients, until I met Jason and had a relatively brief conversation in which he very gently intimated that my business acumen was lacking and that things could be a lot more lucrative. I've been with Jason now for just a little over 12 months, and in that time, my business turnover has more than doubled. I’m just going to say that again. In a little over 12 months, my business turnover has more than doubled! I was an actor in a previous life. On our first day rehearsals at the Royal Shakespeare Company, the director told us to leave our bags and baggage at the door and that we could pick them up on the way out. Jason's very similar in that respect in that he hones what you're really good at and gets rid of all the extraneous rubbish that you don't need to run a successful business. I cannot recommend him more highly and I wish you every success in your journey with Jason.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/calesinfield/",
      id: 54,
      name: "Cale Sinfield. Kangaroo Connections.",
      profilePic: calesinfield,
      review:
        "Jason Cornes is an exceptional business coach and a genuinely lovely guy. His deep knowledge and personalised approach really helped me navigate challenges in my business, and I always felt supported. Jason listens, understands, and provides actionable advice that makes a real difference. If you're looking for a business coach who truly cares and knows his stuff, I highly recommend Jason. He’s been a game-changer for me!",
    },
    {
      linkedIn: "https://www.linkedin.com/in/jzdonegan/",
      id: 55,
      name: "John Donegan. Associate Director. Streets Chartered Accountants.",
      profilePic: johndonegan,
      review:
        "My firm engaged with Jason to help me develop leadership skills so I could work towards moving from a manager to a director over the next few years. Having been with Jason for only 9 months, my skills have developed rapidly, in not just my mindset, but the language I use and the body language I portray. These developments have not just helped me in the office but has also been noticed by friends and family in my personal life too! So far, we are ahead of schedule already receiving a promotion to associate director after 7 months of work. I would whole heartedly recommend anyone who is looking to develop themselves and grow to speak to Jason. He is very easy to talk to, and great at helping you rethink your questions or goals into a way that takes jargon out of it, making it tailored to you, your needs and the issues you are facing!",
    },
    {
      linkedIn: "https://www.linkedin.com/in/martyn-beaumont-8b67436/",
      profilePic: MartynB,
      id: 85,
      name: "Martyn Beaumont. Design and Product Ltd",
      review:
        "Jason is an excellent coach. He will challenge you, make you think deeply about your goals and help you set a path to get there. He has a wealth of experience and that really shines through from the first session. You also really feel like you have someone 'In your corner'. I would very much recommend Jason if you are thinking of getting a business coach!",
    },
    {
      linkedIn:
        "https://www.linkedin.com/in/elizabeth-keates-film-photography/",
      profilePic: ElizabethK,
      id: 84,
      name: "Elizabeth Keates. Photographer and film maker.",
      review:
        "I am thrilled to share my feedback for my exceptional business coach who has been instrumental in the growth of my business and the successful onboarding of a new team member. Working with my business coach has been an absolute game-changer for me. Jason’s expertise, guidance, and support has truly transformed my business in ways I never thought possible. From the very beginning, Jason has been a constant source of inspiration, motivation, and invaluable knowledge. With Jason’s strategic advice and practical tips, I was able to focus on what could be achieved rather than what could happen if I fail. My desire to stay inside my safety net was so strong, it was holding me back… thankfully Jason was stronger. He took the armbands off and I am now swimming with the adults in the deep end!! I cannot express my gratitude enough for the positive impact Jason has had on my personal and professional growth. In conclusion, I wholeheartedly recommend my business coach to anyone seeking to take their business to new heights. Jason’s expertise, unwavering support, and genuine passion for helping entrepreneurs succeed makes him an invaluable asset. Jason...Thank you for everything you have done for me and my business!",
    },
    {
      linkedIn: "https://www.linkedin.com/in/karlfuller/",
      profilePic: KarlF,
      id: 83,
      name: "Karl Fuller. 360 Workspace Ltd",
      review:
        "After spending my entire career to date as an employee, I made the jump to establishing my own business as a consultant. Jason has been recommended by five personal contacts, so I booked his Business MOT package. Over the last 6 weeks he has given me a framework to help set up key processes to becoming profitable. He has given me numerous insights into running my own business, helping me avoid costly mistakes and fast tracking the successful set up process. From marketing, finance, KPIs, there is nothing he hasn't been able to guide me on. I would recommend anyone who is either stuck in a rut, or looking to make big improvements to their business, or like me taking the step away from being an employee - give Jason a call!",
    },
    {
      linkedIn: "https://www.linkedin.com/in/stuart-gardiner-42187016/",
      profilePic: StuartG,
      id: 82,
      name: "Stuart Gardiner. Brass Tacks Design London Ltd",
      review:
        "I approached Jason during a financially challenging period, seeking help to restructure my business. Over the course of six months, his impact has been profound. Thanks to his guidance, I have regained my confidence and ambition, and I've attracted more new clients than I ever imagined possible. Jason doesn't offer an easy ride; he challenges you and asks tough questions, which are crucial for identifying necessary changes in your business. His analytical approach, combined with years of real-world business experience, has provided invaluable insights and strategies. I highly recommend Jason to anyone looking to enhance profitability, sharpen their focus, and transform their mindset for the better!",
    },
    {
      linkedIn: "https://www.linkedin.com/company/matthew-giles-architects/",
      profilePic: mattG,
      id: 81,
      name: "Matt Giles. Matthew Giles Architects.",
      review:
        "When I first met Jason 6 months ago, he told me “that we would be going on quite a journey together”. I had no idea what he meant at the time, now I certainly do. I was ambitious, but I felt lonely and very stuck. Jason is a breath of fresh air and gets straight to the point. He strips back what you think you know and takes you back to basics. My business is now able to move forward because I know where I want to go. Jason may take you out of your comfort zone – I say ‘let him’ – this is how we progress! In six months, I have experienced a complete change in the way in which I look at my business. I am excited about the future and changes are happening. I cannot praise Jason highly enough and I look forward to many years of working together.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/inga-kopala-2a82012/",
      profilePic: IngaK,
      id: 80,
      name: "Inga Kopala. Amberth Kitchens Bathrooms and Interiors",
      review:
        "Having Jason as my business coach has been incredibly beneficial. He excels at holding me accountable, ensuring that I stay focused on my goals. The questions he asks are always insightful, leading to new perspectives and innovative solutions. His experience and knowledge are a constant source of guidance. I particularly value the flexibility of our sessions; we're not confined to a set program, which allows us to address the most pressing areas of my business. This customized approach has helped me to work towards my short-term goals and stay on track for my three-year growth plans.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/francesthapen/",
      profilePic: francesT,
      id: 79,
      name: "Frances Thapen. School Development Ltd",
      review:
        "I've worked with Jason for nearly two years now and I love how fearless I feel in his sessions. He helps me to question all of my assumptions about working in education and helps me to build the business and the lifestyle that I want. My company is set up to support and provide bespoke curriculum services to schools in the UK. When I started working with Jason, I was a self -employed consultant working on my own and I now run a small agency with up to 10 consultants working remotely, partnering specialist consultants with classroom teachers. I'm really looking forward to our next session because since I last saw Jason a couple of weeks ago, I've decided to set up an app to serve my schools even better and by the time I meet him next week, I'll have got the first draft almost completed. It's looking really good and it's going to open a whole extra service channel for me to be able to bring the work that we do to more schools. One of the parts I loved most about working with Jason was that in our first session, he identified a part of my character that I hadn't really noticed before, that I was much more suited to working as a consultant within an agency. That insight helped me to develop a business which matched my personality better, that helped me to find a way of working that could bring out my strengths rather than fit into a mould.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/carol-seaborne-813a09199/",
      profilePic: carolS,
      id: 78,
      name: "Carol Seaborne. The Back Care Clinic Ltd",
      review:
        "My name's Carol, I'm from The Back Care Clinic. I've been working with Jason Cornes for about 8 -10 months now and it's been a fantastic experience. When I think where I was last summer, I was stuck, I felt alone, I felt very anxious about my business. I've got all of these plans, I've got all of these ideas about moving my business to working more online and I just didn't have a clue how to do it, where even to start. So Jason has taken me right back to basics, really nailing my products, knowing who my ideal clients are and really crystallising that whole vision of where I actually want to take my business. He has made me uncomfortable, he has pushed me, he's encouraged me and he's really, really listened to me and it's brilliant because I've been able to be vulnerable with him about things that I've not been sure about. It's been an incredible experience and I really hope to carry on working with him as my business goes from strength to strength. I highly, highly recommend Jason, he's just been brilliant.",
    },
  
    {
      linkedIn: "https://www.linkedin.com/in/laurence-katz/",
      profilePic: laurenceK,
      id: 77,
      name: "Laurence Katz. Elemental Studio Ltd",
      review:
        "I've worked with Jason for the last 6 months and he has seen me through the ups and downs of business ownership during a tough time. With Jason's help, I've managed to find my mojo back, planned the next 5 years of my studio and I started outsourcing vital tasks which are proving to be a huge help in scaling up my whole organisation. Thank you very much for your help and guidance through that process",
    },
    {
      showLinkedIn: "d-none",
      profilePic: FrancineW,
      id: 76,
      name: "Francine Widdows. Eyelash Excellence Ltd",
      review:
        "Working with Jason has been nothing short of transformative for me and my business. When I first reached out to him, I was feeling stuck and lonely in my entrepreneurial journey, unsure of how to move forward and lacking the confidence to take the next steps. From our very first session, Jason's guidance and support have been invaluable. Not only has he provided expert business coaching, but he has also served as a counsellor, helping me navigate through personal challenges and understand how my personality type impacts my work. One of the most remarkable aspects of working with Jason is his ability to shift my mindset from negative to positive. Negativity had become a default setting for me, but Jason's insightful coaching and encouragement have helped me break free from that cycle. Thanks to Jason's guidance, I've gained clarity on my goals, developed a stronger sense of self-awareness, and cultivated the confidence to pursue my dreams. I'm no longer just surviving in my business – I'm thriving, and I owe much of that success to Jason's unwavering support and expertise. If you're feeling stuck, overwhelmed, or unsure of how to move forward in your business, I wholeheartedly recommend reaching out to Jason. His unique blend of business coaching and counselling has been a game-changer for me, and I have no doubt he can help you achieve your goals too",
    },
    {
      showLinkedIn: "d-none",
      profilePic: sylviaA,
      id: 75,
      name: "Sylvia de Araujo. The School of Learning and Achievement",
      review:
        "Without hesitation, I would recommend Jason as a business coach. I contacted Jason when my business was, and still is in its very early stages. In only a short time, Jason has helped me to see the potential of my business, with his expert advice and wealth of knowledge of upscaling any business. However, not only does Jason, with yourself, look at planning to grow your business, he also understands the importance of having the correct mindset to achieve the goals you want to achieve. Jason’s input is invaluable to myself; as I continue on my journey to entrepreneurship.",
    },
    
    {
      linkedIn: "https://www.linkedin.com/in/victoria-ramsden-abb8a45/",
      profilePic: victoriaR,
      id: 73,
      name: "Victoria Ramsden. Integrity Executive Coaching.",
      review:
        "I had been looking for a coach for some time and had spoken to a few coaches before I remembered I knew of Jason. I knew immediately he was what I had been looking for. I’ve had my business for a while and knew I needed another level of distilling what I was offering to more closely reflect my personal values, purpose and aims for my coaching business. As any good coach knows, when we are working solo, even though we know deep down what we want, it’s hard to step outside of ourselves and land on the right language to appropriately express what we do, to those clients we serve best. Jason has held the mirror up, generously shared his rich insights and experiences which have been so valuable in cementing things that I’ve logically known but that I needed to sink in and be applied to my specific context.  Others say this too, Jason’s approach is no-faff and he gets the job done and done brilliantly. We haven’t yet concluded our time together and yet I have already seen the impact of working with Jason, and as we landed on my updated strap line, it literally bought tears of joy (we laughed about this!), having been grappling with this for months. Coming from another coach, I’d like to think this is high praise and truly deserved for the value Jason has given me and my business!",
    },
    {
      linkedIn: "https://www.linkedin.com/in/richardjamesworsfold/",
      profilePic: richardW,
      id: 72,
      name: "Richard Worsfold. Branding Box.",
      review:
        "I have been working with Jason Cornes, a business coach, over the past six months. At the start of the process, I was time-poor and trying to juggle too many plates, some of which were not making any money. During the coaching process, Jason has helped me to identify my target market, develop client avatars, and refine my services to align with the needs of these client types. I have found the whole process extremely useful, and having Jason as a sounding board for ideas has been invaluable. Jason frequently pushes me on my decision-making and ensures I have looked at all of the options before making an informed decision. If you are looking for a business coach who is straight-talking and not afraid to point out areas of development and push you to improve, Jason is your coach!",
    },
 
    {
      showLinkedIn: "d-none",
      profilePic: matt,
      id: 68,
      name: "Matt at Cranfield IT",
      review:
        "I have had the pleasure of working with Jason Cornes for around 6 months now, and I can honestly say that it was one of the best decisions I've ever made. His knowledge and expertise in the business world is invaluable, and he provides me with the guidance and support I need to get my business up and running and reach that next level. He is always available to answer questions, provide advice, and brainstorm new ideas all in a confidential manner. His enthusiasm and dedication to my success is a real inspiration. I highly recommend Jason’s business coach services to anyone who is feeling stuck In their business, as Jason provides a fresh perspective and expert advice that truly gives you that boost of positivity that’s needed to run a successful business. I continue to work with Jason to keep up-levelling and I’m very excited to see what 2023 will bring. Thanks again and look forward to our next meeting.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/pierre-bauz%C3%A9e-233b058b/",
      profilePic: pierreB,
      id: 67,
      name: "Pierre Bauzee. Beyond Satisfaction Ltd. Customer Service Specialists.",
      review:
        "Jason is such a great coach and has been an amazing help and support for me and my business on so many aspects. Definitely recommended! Thank you again Jason.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/christianparkerredrag",
      profilePic: chrisP,
      id: 66,
      name: "Christian Parker. Red Rag Marketing Ltd.",
      review:
        "Jason not only is a great human being, but the way caters for his clients is remarkable. I honestly would recommend Jason if you were looking to grow your business but don't know where to turn to. In the business coaching world, there are lots who don't have your best interest at heart. Jason does.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/harry-whale-94471145/",
      profilePic: harryW,
      id: 70,
      name: "Harry Whale. Classic Car Consultant & Motorsport Showroom Ltd",
      review:
        "I can't recommend Jason's services high enough. Coming from 10 years being an employee to starting my own business in more recent times, Jason has been superb in guiding and challenging my thinking, which has accelerated my personal learning process hugely. Thanks again Jason",
    },
    {
      linkedIn: "https://www.linkedin.com/in/giuseppe-parla",
      profilePic: giuseppe,
      id: 71,
      name: "Giuseppe Parla. Director & Insolvency Practitioner – Business Recovery Menzies LLP",
      review:
        "I was fortunate enough to spend some time with Jason to run through my personality type. It was a real eye opener for me, but also a very honest look at the mirror. Jason clearly described all the scenarios, providing great examples to bring the different personality traits to life. We then ran through all the pros and cons, to understand my character strengths and weaknesses. This is a really interesting topic for me and something I have always been keen to explore. I am sure that working through this with Jason and following up with my own research into my personality traits, will lead to me towards being the best I can possibly be, both from a personal perspective, as well as in a business sense.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/lou-mcintosh-712ab920",
      profilePic: lou,
      id: 65,
      name: "Louise McIntyre. Printingprogress Ltd",
      review:
        "Jason is a breath of fresh air and an incredibly talented business coach. If you are looking for someone to inspire you and help you to see how you can grow both your self-confidence and business then look no further. I have had many business coaches that work to a model that has never quite suited me or my business, but Jason is different he adapts his expertise and meets you exactly where he makes the most impact. Highly Recommended.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/jessica-cox-63358948",
      profilePic: jessC,
      id: 64,
      name: "Jessica Cox. Interior Designer. Jessica Cox Ltd",
      review:
        "I have just worked with Jason on an MOT for my business, and even after the first session I had a much clearer idea on what I needed to change and focus on moving forward. I am excited to put the action points in place and implement the changes (in fact I already have and am already noticing a difference)! Jason is great to work with and is really encouraging whilst challenging the areas that I needed to relook at, so I know now what my focus is, which in turn is going to help my business grow. I can fully recommend the MOT service for any small business - it's invaluable. Now looking forward to reporting back and telling him all about the progress!",
    },

    {
      linkedIn: "https://www.linkedin.com/in/kolostapler ",
      profilePic: kolos,
      id: 63,
      name: "Kolos Tapler. Accountant. No 1 Accountants Ltd ",
      review:
        "I was inspired to book a business MOT with Jason as I heard other business owners say how useful it was for them. It might seem contrary to what is expected or even ironic that the owner of a firm of accountants, that look after and advise small business clients, albeit with a financial focus, would himself want a business MOT. The reality is that all of us can get ‘lonely in business’ and benefit from a fresh perspective and a safe space to explore what we really want for ourselves and our team and how we are going to achieve that. My business MOT with Jason took place over one month in which we had three meetings. I had the option to contact between meetings if I had a question, felt stuck or wanted to update Jason. Each meeting explored what is important to me and we agreed action points for which I was held accountable.  I approached our first meeting with an open mind and quickly realised that Jason is very experienced in business and a great listener. I was able to explore with Jason what I really want for myself and my team and celebrate our strengths. Thinking strategically, we were also able to identify many tweaks, changes and improvements to enhance an already successful accountancy practice. I’m very much looking forward to working with Jason going forward and have already recommended several of my own clients for business coaching",
    },

    {
      linkedIn: "https://www.linkedin.com/in/elizabeth-keates-film-photography",
      profilePic: elizabethK,
      id: 62,
      name: "Elizabeth Keates Film & Photography",
      review:
        "Astonishingly brilliant! Two rather powerful words to describe how I felt about Jason Cornes after our meeting. To cut to the chase, which is exactly what Jason did with a business growth issue I had been stuck with for quite a while, I found the session inspirational and I finally have a road map forward. Through hard-hitting truths Jason was able to show me exactly where I was stuck and why. He guided me towards a clear plan of action and together we identified the areas where I feel I need support to enable me to achieve the goal I have been trying to reach for a number of years now. Moments felt productively uncomfortable as we addressed my comfort zone and looked at my self-limiting and destructive cycles, but before my heart rate became too high, Jason quickly showed me ways to reach a solution and above all he has laid a plan to give me the support I need to let go and actually move forward. With Jason coaching from the side-line, I truly can’t wait to report back on where my business will be in 12 months.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/andrew-fenton-25b54414",
      profilePic: andrewF,
      id: 61,
      name: "Andrew Fenton. Chartered Tax Advisor",
      review:
        "I have been working with Jason for several months and I have found his support and ideas invaluable to me. His suggestions and mentoring have produced instant results and I am looking forward to continuing working with him. I would highly recommend Jason to anyone looking for someone to support their business and provide genuine added value.",
    },
    {
      showLinkedIn: "d-none",
      profilePic: stuart,
      id: 60,
      name: "Stuart Long. Solicitor. Dawson Hart Solicitors.",
      review:
        "I highly recommend Jason for anyone that is in a rut and wanting to progress their business further. The discussions/meetings I have had with Jason have been both professional, personable and has given me a completely different perspective as to how I deal with business matters in the future and what I am hoping to achieve in the mid to long term. Jason is a must for anyone in need!",
    },
    // {
    // 	linkedIn: "https://www.linkedin.com/in/jessica-cox-63358948",
    // 	profilePic: jessC,
    // 	id: 59,
    // 	name: "Jessica Cox. Interior Designer. Jessica Cox Ltd",
    // 	review:
    // 		"I highly recommend Jason as an excellent Mentor and Business Coach. I'm really excited to work with him on building strategies and getting back to a clear focus on my business. Even after our initial session I knew it was going to be very valuable, and I’m thoroughly enjoying the process. I wouldn't hesitate to recommend his services to any small business - new or existing.",
    // },
    {
      showLinkedIn: "d-none",
      profilePic: debG,
      id: 63,
      name: "Debbie Greenwood. Liaise Ltd & The People Motivator Ltd",
      review:
        "I met Jason when I was a guest at a networking session and was immediately impressed by his presence and the clarity that he projected when he described his business. The decision was made, I needed Jason to work with me, I needed someone to challenge me - big time! I needed him to help me to get up to hill to the summit, so that I can make my business what I know it can be, but keep falling back and losing motivation and momentum. Now, having worked with Jason, having started with his business MOT, I have to say that it was some of the best money that I have invested in myself and my business, because he isn't just a great coach, he is also a superb mentor with years of experience behind him. As he says on his website, he's made mistakes along the way and is happy to share his them, something that I am very grateful for.. My motivation has returned in spades and I have a clear plan of how I am going to move forward with conviction and more importantly confidence. I now have a new business name which says what I do on the can. I am confident about my niche - and truly understand that this doesn't stop other businesses from hiring me. I am clearer about my USP - which clearly can't be totally unique, but is to me. I am more confident about pricing for my value and not undercharging. I am more confident about my brand. I know the type of people and businesses that I need to focus on to achieve my goals. And I know that there are two Debbie's - Empathetic Deb who works closely with her clients who builds trusting relationships with them. And then there is business Debbie who is looking after her business and charges clients for the benefit and value her experience and expertise will provide them with. Pretty good stuff for 3 sessions, I am delighted! As my business grows I have no doubt that Jason will be that trusted and hidden business partner who will help me get to and beyond where I want to go. Thank you Jason, I cannot recommend you highly enough",
    },
    {
      linkedIn: "https://www.linkedin.com/in/greg-stevenson-b8305736",
      profilePic: gregS,
      id: 58,
      name: "Greg Stevenson. Graphic Designer. Pinpoint Studios",
      review:
        "My time with Jason has been incredibly valuable for my business. He has enabled me to push myself to a place where I have a new mindset driving a reshaped business model, and the systems in place to support it. My sights are on goals much more ambitious than they were previously, and because of questions I’ve asked myself as the result of Jason’s coaching, I’m confident I’ll reach them. He comes highly recommended.",
    },

    // {
    // 	linkedIn: "https://www.linkedin.com/in/carolinesomer",
    // 	profilePic: carolineS,
    // 	id: 57,
    // 	name: "Caroline Somer. Somer Design Ltd",
    // 	review:
    // 		"After only our second meeting Jason offered some very sage coaching advice to help me solve an issue I'd been wrestling with for almost a month! Like a lot of entrepreneurs, running a business can be a lonely game, even with a team. Having a business coach like Jason can help you step back and objectively plan and work through sticking points. I would highly recommend you book a call with Jason to help you get unstuck and plan for the future.",
    // },
    {
      linkedIn: "https://www.linkedin.com/in/mikesherwood147",
      profilePic: MikeS,
      id: 56,
      name: "Mike Sherwood. FreshOnline Ltd",
      review:
        "I have been working with Jason Cornes for the last 5 months and have seen amazing results. Jason has been able to understand my business and identify opportunities to improve what we already do and find new ways to grow and expand. Since working with Jason we have employed another full time staff member, added new services and increased profitability on our existing work. I feel so much more in control and confident about the future. I have no hesitation recommending Jason and I look forward to continuing to use his business coaching services long term.",
    },
    {
      showLinkedIn: "d-none",
      profilePic: nick,
      id: 55,
      name: "Nick Bryant – Brilliant Businesses.",
      review:
        "I recently used Jason to help me with driving my business forward. From the initial meeting I knew he would help me, he approached things in a way that suited me and helped make me see things in a different way, which steered me towards a stronger business model. Jason is very easy to get on with and really listens, he's the best business coach I've used and I recommend that you use him too.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/sarahbennettcommercial/",
      profilePic: sarah,
      id: 5,
      name: "Sarah Bennett Commercial Photography.",
      review:
        "I’ve worked with Jason for two years this month. When I came to Jason for help, I wasn’t entirely sure what a business coach did, I though maybe a few sessions then that was it..2 years on and I can truly say my business has gone from strength to strength, but I still need him. Jason is the person I tell all my ideas to, and bounce them off. He’s the one person that will give me an honest answer and opinion, he tells me what I need to hear, not necessarily what I want to hear. Because he’s always run his own businesses, he knows his stuff, its based on training yes, but more importantly I fell on his 30 years of experience in running his own companies. His ideas are inspiring and I can’t recommend him enough to others.",
    },
    {
      showLinkedIn: "d-none",
      profilePic: shaun,
      id: 53,
      name: "Shaun Stevens. Movo Insurace Brokers Ltd.",
      review:
        "I have used Jason as business coaching mentor and he has been absolutely superb. He always managed to get me to think outside the box and see things from another perspective. I would not hesitate to recommend Jason to anybody needing business advice!!",
    },
    {
      linkedIn: "https://www.linkedin.com/in/antoinette-chappell-b0a83812a/",
      id: 19,
      name: "Antoinette Chappell. Managing Director. ARC Writing and Translation Services.",
      profilePic: antoinette,
      review:
        "I have been working with Jason for six months and in that time I have learnt so much and developed a lot as a person and business owner. What do I like best about working with Jason? His approach to business mentoring, which is both friendly and professional and full of valuable insights into how to successfully run and grow a business. Jason has finely-tuned listening skills and an ability to input information, process it and then output a suggestion that I would never have considered. This means he can drop a career-changing bombshell that ignites a spark that leads to a revolutionary new idea that will transform your life and business forever. He challenges my perception of what I can and can’t achieve, stretching the boundaries of what I thought was possible to the point that the sky is literally the limit! Every time I meet him I come away with my mind buzzing with new exciting ideas about how to improve my business in ways that seem obvious afterwards, but would never have occurred to me on my own. I value his contribution to my business very highly and would happily recommend his services to other businesses that need a fresh approach and guidance from someone with extensive experience of a wide variety of businesses from different sectors.",
    },
    {
      showLinkedIn: "d-none",
      profilePic: liam,
      id: 52,
      name: "Liam Atkins Copywriting.",
      review:
        "If you're considering working with a business coach, stop thinking about it, just speak to Jason. In every session you walk away with another tangible piece of advice or action point that will immediately improve your business. I'd definitely recommend him. Thanks Jason!",
    },
    {
      showLinkedIn: "d-none",
      profilePic: danielle,
      id: 54,
      name: "Danielle Lloyd – TEA Teaching",
      review:
        "Jason is very professional and has vast experience working with a variety of people and uses different approaches depending on his mentee. I have found him a joy to work with as he really understands me and my business. He goes that extra mile to support and help and I warmly recommend him to anyone looking to grow their business.",
    },
    // {
    // 	showLinkedIn: "d-none",
    // 	profilePic: miles,
    // 	id: 56,
    // 	name: "Miles Hall – Lincolnwick Consultants and Resource Providers",
    // 	review:
    // 		"Jason has supported me over the last few months and has helped me develop the right strategy to take my business forward. Thanks Jason!",
    // },
    {
      showLinkedIn: "d-none",
      profilePic: robbie,
      name: "Robbie Mould – RJM Digital",
      review:
        "Jason, Having worked with you the past few months on my business it is clear how your business coaching and mentoring is having a positive impact on how I’m able to focus and grow my company. With your coaching and mentoring I’ve been able to formulate a plan on where I want RJM Digital to be over the next 1 – 5 years. You have helped me understand all the crucial elements of business, identify my company’s strengths and weaknesses, and helped me take ownership of each stage of the journey. If there are any other ambitious business owners who want clarity, accountability, and expertise in working out how to grow and expand their business, I would highly recommend Jason Cornes.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/andy-collins-2b178617/",
      profilePic: andy,
      id: 1,
      name: "Andy Collins. Vostel Ltd",
      review:
        "After an initial discovery meeting with Jason I immediately knew he was someone I could work with. His ongoing guidance and support is superb. I couldn’t recommend him highly enough.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/catherineclifford72/",
      profilePic: catherine,
      id: 2,
      name: "Catherine Clifford. Managing Partner. Best Western Landsdowne Hotel.",
      review:
        "I met Jason at a networking event and straight away I found him to be very easy to talk to and I felt immediately at ease with him. I booked a session with him and I can honestly say that now, after several sessions, I have truly found a way forward for myself and my business. After a simple question about what it was that I actually wanted, it opened the flood gates to a huge amount of possibility that was there but I hadn’t had the courage to tap into. The coaching really helped me to find perspective and clear clouds that were thick and heavy in my mind about tackling challenges and moving forward . It’s fair to say that the clarity and confidence that I have gained from Jason’s business coaching has been invaluable. Thank you Jason!!",
    },
    {
      linkedIn: "https://www.linkedin.com/in/louise-taylor-134b4014/",
      profilePic: louise,
      id: 3,
      name: "Louise E Taylor. Creative Leadership Coach.",

      review:
        "I can highly recommend Jason – he is an excellent coach and mentor. He has enabled me to resolve problems, gain clarity and move my business forward. And he’s got a great sense of humour – invaluable!",
    },
    {
      linkedIn: "https://www.linkedin.com/in/kevin-hinton-b7a28318/",
      profilePic: kevin,
      id: 4,
      name: "Kevin Hinton – kITman Limited.",
      review:
        "I have used Jason as a Business Coach. Jason is unique in the fact that he actually listens to what the business owner requires. And does not work from a preformed business builder script.Along with his knowledge in personal psychology, he can identify problems that can be holding the business back. I can highly recommend using Jason – to develop your business. ",
    },
    {
      showLinkedIn: "d-none",
      id: 6,
      name: "Peter Hill. Dominic Hill Associates Ltd. Chartered Accountants.",
      profilePic: dHill,
      review:
        "Try some learning about YOU I set up Dominic Hill Chartered Accountants in 1992. I understand what it is like to be a small business because I am one. Sometimes you need someone outside your business with no pre-conceived ideas to open your mind to find out what you really want to achieve for yourself and also for your business and in that order. Once you have recognised what you want to achieve you can reset the destination in your life sat nav and set out in that direction. You shouldn’t and can’t re-set the sat nav without stopping to breath. Jason gives you the room to breath, think and then….. move Jason has been really motivating and he makes me smile. I really enjoy the meetings. I thoroughly recommend that you start with a 3 month program because like learning anything you need at least 3 sessions to really start to open your eyes. Why should learning about YOU be any different?",
    },
    {
      linkedIn: "https://www.linkedin.com/in/seldakoydemir/",
      id: 7,
      name: "Dr Selda Koydemir.",
      profilePic: selda,
      review:
        "Jason has helped me get clear on what I really want to do, where I want to go, what strengths I have and how I can use them to achieve my goals, and encouraged me to be more proactive around my business ideas. He has a friendly and challenging attitude which has put me at ease, but also question my mindset and behaviours at the right time. I’m very glad that I’ve had the chance to work with such a great mentor.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/emmapearce/",
      id: 8,
      name: "Emma Pearce. Pearce Marketing Consultants.",
      profilePic: emma,
      review:
        "I have just had a personality testing session with Jason Cornes – and each of my team did too. Hugely enjoyable and insightful – all the feedback from Sophie and Chloe is immensely positive. They found it so interesting – and are already wanting to go more in depth with it. As am I. We can read up about each other’s personality and understand how the world looks though their eyes. If we all have these insights there can only be greater harmony in everything we do. I think we’ll enjoy having a giggle realising how true it all is and then use these new insights to our benefit – for the company and in our personal lives. As a manager it’s very interesting to see how we all have some traits that are alike and suit the ethos and approach of the company, as well as some that are different and useful to keep me on my toes! Brilliant job Jason. Thank you. Highly recommended to all ‘people managers’ for creating a strong and happy team environment.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/jamesgasson/",
      id: 9,
      name: "James Gasson. Third Circle Recordings.",
      profilePic: james,
      review:
        "It seems to me that, for many people, working for yourself can be lonely, confusing and frustrating. After all, we’re good at doing the thing we’re good at, but not necessarily at knowing how to formulate that into a workable, competitive business. I was stuck in this position for many years, not quite confident enough to put my foot down properly, and never sure of the destination were I to do so. Working with Jason has begun to change all that. He has offered direction, focus, and an endless well of positivity, things that have been sorely lacking during my years of struggle and self doubt. His guidance has given me a level of confidence that helps me to stay motivated, even in the face of challenges under which I would otherwise have surely felt defeated, and for that I am extremely grateful. I highly recommend Jason if, like me, you are feeling determined but lost. I look upon our journey with great excitement and readiness, and can’t wait to see where it leads. Five stars indeed.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/russdeacon/",
      id: 10,
      name: "Russ Deacon Home Improvements.",
      profilePic: russ,
      review:
        "We have been working with Jason for nearly 2 years and although we have been in business for many years and think you are going along ok, he pushed us out of our comfort zones, made us question some of our processes as when you have been in business for a long time you do get set in your ways. To rethink how to promote our business, and encouraged us to focus more on the behind the scenes tasks so that we have a clearer idea where our business is going in the years ahead. We enjoy our meetings with Jason and would recommend Jason to any business large or small.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/louisljones/",
      id: 11,
      name: "Louis Jones. Chartered Physiotherapist.",
      profilePic: louis,
      review:
        "I have been working with Jason for about 1 year now and I find his advice and expertise second to none. He made an instant impact on my business, when we started working together, by banishing any negative thought processes and false beliefs I had about money and I saw an increase in sales. He sets achievable goals, which he also holds you accountable for and discusses any concerns and worries that I may have, always putting my mind at ease. Being a business owner himself, he really understands what it is like to run a business. I would thoroughly recommend Jason.",
    },
    // {
    // 	linkedIn: "https://www.linkedin.com/in/lisa-sarsons-164b86129/",
    // 	id: 12,
    // 	name: "Lisa & Brendan of Heatwize Plumbing & Heating.",
    // 	profilePic: lisa,
    // 	review:
    // 		"We were fortunate enough to have been referred to Jason through our local BNI group. It has been an eye opening journey so far with Jason as our business mentor. Jason uses his business experience and life knowledge to guide and assist you to understand the true meaning behind ‘business’. He has taught myself and my partner that emotions do not run a business and this alone has helped us tremendously. Jason’s business mentoring is not simply him telling us what to do, it is him teaching us how and why, it is knowing we have the support there when we need it (and we have needed it!) and it is helping us to fall back in love with our business. I would recommend Jason to anyone looking to get their business back on the right track, to anyone looking to improve their lifestyle and anyone willing to listen to someone [Jason] who has been there and done that!",
    // },
    // {
    // 	showLinkedIn: "d-none",
    // 	id: 13,
    // 	name: "Silvia Hartmann. Creator of Modern Energy and Star Matrix.",
    // 	profilePic: silvia,
    // 	review:
    // 		"I have just completed a three months experience with Jason and I found it most beneficial. Jason is personable, knowledgeable and very cheerful. He has provided a much needed outside perspective on my family company which will undoubtedly prove more than valuable in the years to come. I also found we generated many new ideas that I could implement right away for great results. Running a business is all consuming, and to find a time and space to discuss essential concerns, plans and ideas for the present is truly precious. Jason Cornes provides this space, and I highly recommend working with him",
    // },
    // {
    // 	linkedIn: "https://www.linkedin.com/in/darrell-deeprose-8ab3ab177/",
    // 	id: 14,
    // 	name: "Darrell Deeprose. Concept Building Solutions.",
    // 	profilePic: darrell,
    // 	review:
    // 		"If it wasn’t for Jason I would probably still be going round in circles with no idea how to stop and move forward…. Jason has helped me to move on to the next level with a clear vision and strategy… Can’t thank you enough",
    // },
    {
      linkedIn: "https://www.linkedin.com/in/sarahbennettcommercial/",
      id: 15,
      name: "Sarah Bennett Commercial Photography.",
      profilePic: sarah,
      review:
        "I’ve used Jason’s service for over 18 months now and I have to say it’s been a game changer for my business. Jason listens and gives ideas but doesn’t tell you what to do. His approach is bespoke to every business and so you get a tailored plan not an off the shelf one size fits all. This means you’re applying ideas that really work and make a difference. I would seriously recommend Jason to any business owner who is struggling to see the wood for the trees and need a helping hand to get back on track.",
    },
    // {
    // 	linkedIn: "https://www.linkedin.com/in/jordan-hay-ellis-458a1b97/",
    // 	id: 16,
    // 	name: "Jordan Hay-Ellis. Director. Character Construction Ltd.",
    // 	profilePic: jordan,
    // 	review:
    // 		"Jason has joined us in the capacity of both Business Mentor and Life Coach. Within our business he is an essential asset, his approach to business planning is focused on achieving goals by breaking them down into manageable milestones. As a personal Life Coach he has opened up some very intriguing conversations that help us to understand ourselves, our clients and business partners on a much deeper level. Our journey with Jason is still very much at its start, but we are already very happy with what he has to offer and very much look forward to where our business can go with him as part of our team.",
    // },
    {
      linkedIn: "https://www.linkedin.com/in/tristanbund/",
      id: 17,
      name: "Tristan Bund. Tristan Bund Architecture.",
      profilePic: tristan,
      review:
        "I’ve been working with Jason for a while now and find him to be extremely professional, supportive and a fantastic listener. His abilities go way beyond just mentoring. I trust Jason to improve any business and as such would thoroughly recommend.",
    },
    {
      linkedIn:
        "https://www.linkedin.com/in/aryajit-heppell-%F0%9F%9A%80-5a804538/",
      id: 18,
      name: "Aryajit Heppell. London Explainer Videos.",
      profilePic: aryajit,
      review:
        "I highly recommend Jason as an excellent Mentor and Business Coach. He’s very perceptive, methodical an experienced. He is also challenging when necessary. I leave our meetings feeling more motivated and clear on what I’m doing in my business. I’m thoroughly enjoying working with him.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/alan-norton-807661aa/",
      id: 20,
      name: "Alan Norton. Managing Director. Equilibrium Building Solutions Ltd",
      profilePic: alan,
      review:
        "For those of you business owners out there who think you can’t afford a business coach, think again! You are probably finding yourself in some financial difficulties at present or need a new direction. Can I really afford him, I hear you ask.? The very reason you’re running your own business, is that you want to do it your way, a leader not a follower. We all struggle from time to time and lose our way. I urge you to contact Jason. This is a man who has ‘walked the walk’! He will listen to your current situation, your goals and dreams. He will understand you and create an action plan for your success. Always there to offer you support as and when you need it. I took the leap! In just 3 months my business has grown, I now know where I’m going and where I want to be. I am attracting specific enquiries and as such I’m doing the work I love. It’s no different than using a fitness coach but for your business. Trust me, you’ll see the results",
    },
    {
      showLinkedIn: "d-none",
      id: 21,
      name: "Claire White – Pugs in a Tub Dog Grooming, Eastbourne",
      profilePic: claire,
      review:
        "It is such a weight off my mind to have Jason’s ongoing support and encouragement to grow my already successful business. He has re-lit my passion for my work and my confidence has grown enormously. Firstly, I found the personality profiling exercise absolutely fascinating.  Why? Because it helped me to understand why I do things in a certain way.  And, how I can try different approaches to overcome everyday challenges. It’s obvious that Jason understands business.  Also, it’s great to bounce my ideas around to come to conclusions needed. Jason keeps me on track and I’m more relaxed because I know I am going in the right direction. Our sessions are a combination of fun and serious moments in just the right balance. If you are a small business owner like me, I suggest you make time to meet Jason for a coffee. I’m glad I did.",
    },
    // {
    // 	linkedIn: "https://www.linkedin.com/in/margaret-sinclair-832a6a2b/",
    // 	id: 22,
    // 	name: "Margaret Sinclair. Nadarra Cosmetics.",
    // 	profilePic: margaret,
    // 	review:
    // 		"I would highly recommend Jason as a business coach. He has a key skill many coaches don’t…he listens. To who you are, what you want, what you believe in, where you are and where you want to be. He then tailors his approach to suit you. Giving a truly bespoke mentoring and coaching service that is invaluable.",
    // },
    {
      linkedIn: "https://www.linkedin.com/in/jon-shortell/",
      id: 23,
      name: "Jon Shortell. Commercial Client Director. Movo Insurance Brokers Ltd.",
      profilePic: jon,
      review:
        "In business, sometimes you simply cannot see the wood for the trees. I can honestly say that following an initial meeting with Jason, I have a far greater appreciation and clarity of the possibilities which are open to me. Being slightly cynical of business coaches in the past, I can only say now – “Don’t knock it till you try it” – I thoroughly recommend any business having a chat with Jason Cornes.",
    },
    // {
    // 	showLinkedIn: "d-none",
    // 	id: 24,
    // 	name: "Rhys Watford. Managing Director. Smart Services Ltd",
    // 	profilePic: rhys,
    // 	review:
    // 		"I’ve had more than six months of mentoring sessions with Jason so far and would highly recommend him. He is very insightful and able to apply his extensive knowledge of running a business to help others. After only 3 sessions on one area of my business, he was able to increase it’s profit by 40%. This result alone makes Jason a no-brainer when it comes to choosing a Business Coach and I would recommend him to anyone wanting to improve their business and/or get some help and focus and move in the right direction.",
    // },
    // {
    // 	showLinkedIn: "d-none",
    // 	id: 25,
    // 	name: "Jacqueline. Small Business Owner. Croydon.",
    // 	profilePic: pier2,
    // 	review:
    // 		"I have just signed up with Jason and I was so impressed with our first session that I offered to give a testimonial and I have recommended another business owner friend. Jason has a creative, insightful mind and gave me a good wake up call about my business! He saw what I was doing well but more importantly where I need to focus and improve. On the technical side, he has a great understanding of how to make your business work for you. On the day to day practical side he is already encouraging me to get out there and do things I should be doing. Jason is a fantastic listener and gives useful feedback in abundance. He has already spotted opportunities for my business that I hadn’t thought of. His enthusiasm and focus are infectious and I’m excited to be working with him",
    // },
    {
      linkedIn: "https://www.linkedin.com/in/andrea-birch-07653544/",
      id: 26,
      name: "Andrea Birch. Digital Workshops Partnership Ltd.",
      profilePic: andrea,
      review:
        "Jason is a super presenter and business coach as his testimonials will continue to endorse I’m sure. He’s very insightful and gives well considered advice to his clients . Even his pauses are instructive. He clearly knows his subject and has a lot more knowledge to offer which explains why us business owners continue to make rather uninformed decisions . If you need a Business Guru then Jason is so worth meeting up with and discussing whether there isn’t perhaps a simpler, a better, happier more productive way we can run our businesses in 2019 and beyond.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/clare-payne/",
      id: 27,
      name: "Clare Payne. Social Bee Social Media.",
      profilePic: clare,
      review:
        "I would recommend Jason’s Business coaching without hesitation! He has helped us change our whole mentality and see things in a completely different way. Jason has helped us start to gain the financial intelligence we never had. With his advice we have finally started to outsource the jobs that we were being bogged down with, giving us time to do the things we should be doing. If you are serious about changing your business from the hobby it started out as in to the serious business you want it to be, speaking with Jason could just be the game changer you need! Thank you Jason!",
    },
    {
      linkedIn: "https://www.linkedin.com/in/moxychild/",
      id: 28,
      name: "Moxy Child. Moxy Commercial Photography.",
      profilePic: moxy,
      review:
        "Jason is a coach who actually LISTENS! – I would highly recommend his services to anyone in business. Jason gave me the courage to scrap my old business identity and to start afresh. He supported me through the whole business of putting things into place properly rather than haphazardly as was done before.",
    },
    // {
    // 	showLinkedIn: "d-none",
    // 	id: 29,
    // 	name: "Chris Novis – Branding Consultant.",
    // 	profilePic: chris,
    // 	review:
    // 		"Jason has been the best investment not only for my business, but for my work-life in general. I feel so much more confident about pricing and the structure of my business, which is paying off greatly. I would highly encourage anyone who is interested in working with Jason to book him right now for a discovery meeting.",
    // },
    // {
    // 	showLinkedIn: "d-none",
    // 	id: 30,
    // 	name: "Michael Business Owner East Sussex.",
    // 	profilePic: pier2,
    // 	review:
    // 		"In the 6 months since I enlisted his help to grow my business sales have almost doubled! He has been the most valuable investment my business has made, helping me to focus my time, money and staff resources more wisely, and strategically. He is skilled at quickly identifying priorities and keeping me focused. Jason understands how to grow a business. I highly recommended him",
    // },
    // {
    // 	linkedIn: "https://www.linkedin.com/in/helen-burton-3a7569146/",
    // 	id: 31,
    // 	name: "Helen Burton – Eastbourne Volunteers.",
    // 	profilePic: helen,
    // 	review:
    // 		"Jason mentored me for a year when I first launched my community interest company Volunteers Network. He helped me to prioritise my workload, develop a work/life balance and also develop a business plan that has seen our company grow exponentially over the last five years, supporting all sorts of community initiatives. The focus he helped me to develop was invaluable. Helen",
    // },
    // {
    // 	linkedIn: "https://www.linkedin.com/in/sarahbennettcommercial/",
    // 	id: 32,
    // 	name: "Sarah Bennett Commercial Photography.",
    // 	profilePic: sarah,
    // 	review:
    // 		"I didn’t think I needed a business mentor, but then things got really tough. I was very low, lost my way and my focus on what I was doing and which direction I was going in. I spent my days doing the wrong things, chasing down the wrong types of leads and getting nowhere fast. I knew in my mind what I had to do but didn’t have a clue how (or the courage) to go about it. Others had told me how Jason had changed their business and personal lives for the better so I bit the bullet. From the first meeting I felt empowered to make change. From meeting three even though most of the changes made were subtle and behind the scenes so to speak, the RIGHT activity, calls and leads started coming in. Jason helped me changed my mindset and beliefs and in turn that changed my business for the better. Jason listens but doesn’t force his opinions on you, he offers them, asks questions and makes you question and question again what you’re saying is right for you. He doesn’t insist you do something you’re not comfortable with or you don’t believe in, unless it’s an essential part of moving forward. I enjoy our meetings immensely. We set action points and I look forward to putting these into place because I can see they make a difference. I’m now working on a new website based on the positive changes we’re making and I’m so excited. I would happily recommend Jason to anyone who’s lost their way in business.",
    // },
    {
      linkedIn: "https://www.linkedin.com/in/mariia-savvinova-814320157/",
      id: 33,
      name: "Mariia Savvinova. Health and Beauty Massage.",
      profilePic: mariia,
      review:
        "All of the most successful business empires have founders who had mentors. Facebook’s Mark Zuckerberg was mentored by Steve Jobs. Steve Jobs was mentored by Mike Markkula the investor in Apple. I was thinking to go to the college to study management. However after spending a lot of money I would have no business and no business experience at the end of the course. There was another, better alternative – to find myself a business mentor. A business mentor will help you not only to save your money, but will help you to build a successful business. Thankfully at a business networking meeting I’ve met a very good one and you now have too! Our first discovery session was free which helped us to know each other better and we became a good team. I am managing my health and massage business alone and some tasks and projects I had been trying to do for at least a year, but with Jason’s mentoring it was done in just a few weeks. Jason has years of experience in the small business field and he has a network of professionals and business owners who he can introduce you to. This is a good resource and opportunity when you have a mentor. Jason is a very professional, nice, kind and polite person. All sessions is confidential which I like. He can make you stronger and to help you find shorter way to success. We all often deal with depression when we are unable to meet our goals and have our expectations met. Jason is not just a Business Mentor and Life Coach but he also encourages you with positive and soothing words of advice when things refuse to go your way. Jason practically guides you and shares your worries, keeps you reassured that you are successful which helps to increase your self-confidence. To having high self-confidence contributes significantly to career success more than talent and competence. Jason helps me to see every challenge as an opportunity which helps me to keep going forward with my business with a positive mind-set. If I need any advice or consultation I can reach Jason any time by calling him or having an online chat. If you are in the middle of the road and you don’t know where to go at the moment, which way would lead you to success. If you are afraid to start your business or expand your existing business than Jason is definitely the right person for you! I am enjoying our work together very much and we will be continue our great partnership. I consider it to be a great investment. Time is money. Don’t waste your time with doubts, just contact Jason and all your questions will be answered",
    },
    {
      linkedIn: "https://www.linkedin.com/in/andrew-durling-9408853a/",
      id: 34,
      name: "Andrew Durling – Social Entrepreneur.",
      profilePic: andrew,
      review:
        "I can thoroughly recommend Jason as a business mentor because he is indeed a mentor, and an excellent one at that. His listening skills are superb and he always responds with insight and practical advice. I gained invaluable assistance from my mentoring sessions with Jason and wouldn’t hesitate to use his services again if I’m in need of them. Jason clearly has deep knowledge and experience of the unique challenges involved in starting up, or running, a business, and knows what it takes to transform what seems a daunting challenge into an opportunity for both business and personal growth. Jason was able to create a safe, welcoming space in our mentoring sessions in order to explore my own personal and business experiences, identify any issues unresolved or needing to be addressed, and to come up with creative solutions or at least discover the skills and resources I already have which could be used to find the solutions needed. His scrupulous attention to detail and the great care he took to put me at ease and to create the right conditions to make the mentoring sessions work, gave me great confidence in him, which paid off handsomely as the sessions progressed",
    },
    {
      linkedIn: "https://www.linkedin.com/in/daniel-brookbank-83b88b2a/",
      id: 35,
      name: "Daniel Brookbank. Chief Executive Officer.",
      profilePic: daniel,
      review:
        "At the age of 50 and having reached a high level in my chosen field I knew that I needed to look at what I was doing and how it fitted with my work/life balance. I wanted the opportunity to work in a more flexible manner and to have time to explore and succeed in other projects. Jason helped me to analyse where I am now and where I want to be, but much more importantly, he helped me find the path to my future. From starting with a whole lot of unanswered questions I ended up with clear answers and achievable goals. Jason’s questioning was clear and challenging and his advice sound and logical. He spent time making me think and understand and he helped me to see clearly through a whole lot of different ideas. I was very pleased that by the time we came to the end of our sessions he had pointed and guided me in such a way that I know what I need to do and how to do it. I would recommend Jason to anyone who is looking to move their career forward or just needs some guidance to help them make changes.",
    },
    // {
    // 	showLinkedIn: "d-none",
    // 	id: 36,
    // 	name: "Name withheld – Life Coach in the Brighton Area.",
    // 	profilePic: pier2,
    // 	review:
    // 		"Jason has a take-charge style and is kind and humorous. There is nothing ‘off the shelf’ about his approach. He really wants you to succeed and will do everything he can to be supportive. Being a sole trader it was so nice and such a relief to be able to share with someone who I trust and knows what he is talking about. Even though we are from different towns I was concerned that Jason would view me as a competitor, but when I contacted him but he was very open and happy to meet. Jason is helping me grow my coaching business and we say in the industry that a coach who can coach coaches is good at what they do! Thank you Jason",
    // },
    // {
    // 	linkedIn: "https://www.linkedin.com/in/jannine-howe-8ba812175/",
    // 	id: 37,
    // 	name: "Jannine Howe – Bourne to Achieve.",
    // 	profilePic: jannine,
    // 	review:
    // 		"Jason was recommended to me by another local business owner. His free discovery meeting was very helpful in exploring how he could help me grow my tutoring business. Jason oozes professionalism and confidence. He nudges and holds you to account – as is the role of the coach and mentor, and listens to you as an individual, recognising your way of working. Highly recommended investment.",
    // },
    // {
    // 	linkedIn: "https://www.linkedin.com/in/alan-norton-807661aa/",
    // 	id: 38,
    // 	name: "Alan Norton – Equilibrium Building Services Ltd.",
    // 	profilePic: alan,
    // 	review:
    // 		"After looking and researching business coaches, I decided to put my trust in Jason. He was so much more value for money as the others were very expensive. This coupled with his previous business background and reviews he was the obvious choice. Jason is a great listener, making you feel at ease. He gently points you in the direction you naturally want to go offering support along the way. I was working as a general builder, my aim was to specialise! Jason will listen to your fears and concerns and will not judge you. He sets out some project research for you to do, when this is done you feel that you are closer to where you want to be. I have met Jason around 10 times now and really noticed a big difference in my attitude to my work life. I’m so pleased that I made the right decision, give this guy a call and try his free initial discovery session, you won’t regret it!!",
    // },
    // {
    // 	showLinkedIn: "d-none",
    // 	id: 39,
    // 	name: "Luke Watts – Social Entrepreneur",
    // 	profilePic: luke,
    // 	review:
    // 		"Wonderful skill-base, knowledge and contact. Exceptional listening skills and really focused on the direction of my social enterprise. I strongly recommend Jason.",
    // },
    {
      linkedIn: "https://www.linkedin.com/in/gregdraven/",
      id: 40,
      name: "Greg Draven – Actor.",
      profilePic: greg,
      review:
        "I’ve been visiting Jason for some months now and I have to say the service I have received is amazing. Jason has really helped me focus my business efforts to where they should be going not on wasting time on meaningless endeavours. I have found Jason’s approach to be relaxed yet professional and I can’t thank him enough for all the help he’s given me.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/marie-dove-a66aa743/",
      id: 41,
      name: "Marie Dove – Marie Dove’s Fit Club",
      profilePic: pier1,
      review:
        "Dear Jason, I write to thank you for the recent business coaching you have provided me. In a nutshell, as a ‘one man band’ business it can often be very hard making decisions and knowing the right way to steer my business. This is why I was interested to meet you for one of your free ‘Discovery Meetings’ to see if and how you could help me. After the hour session, not only was I really impressed with your knowledge of business, but also your background in psychotherapy. Also, I really liked the blend of personal and business. Therefore, I was very pleased to use your business coaching services. I have just completed my first month with you. I now feel completely different about business and the way I approach it. You have challenged my way of thinking in many ways and I have often left our meetings feeling a bit ‘discombobulated’ but in the very best way. Your approach has been supportive, encouraging without a doubt. However, that’s not all. It’s also challenged me, nudging me in different directions. Like a Dolphin parent, you have nudged and guided me. Sometimes you swam ahead, sometimes alongside but always letting me swim at my own pace and direction. I am extremely excited about my business in 2019 and would highly recommend your services to friends and colleagues. Many Thanks.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/jane-long-9203335/",
      id: 42,
      name: "Jane Long – Calm Therapy Reflexology",
      profilePic: jane,
      review:
        "Working with Jason has given me a new insight as to how my business can grow. I always have so many ideas but end up going round in circles. With the help of Jason’s direction and knowledge, my business is beginning to blossom in ways that I would never have expected.",
    },
    // {
    // 	showLinkedIn: "d-none",
    // 	id: 43,
    // 	name: "Rachel Ainsley – Business Owner.",
    // 	profilePic: pier2,
    // 	review:
    // 		"I have been visiting Jason for a few months and he has helped me immensely. He has helped me gain focus and grow my new business, highly recommended!",
    // },
    {
      linkedIn: "https://www.linkedin.com/in/liz-george-06471b166/",
      id: 44,
      name: "Business Owner – Liz George Wellbeing Centre",
      profilePic: liz,
      review:
        "I started working with Jason to set up my therapy business. I had tried to do it on my own and after a few false starts I realized I needed to find an expert business mentor. I am very fortunate to have found Jason as he has helped me develop and implement a very successful business model and marketing strategy. This would never have been possible without him. Jason keeps me on track and is available to give feedback on any aspects of my business. He is a true professional and is always there to help and give support. I highly recommend Jason and consider myself very fortunate to have him as my business mentor.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/louisljones/",
      id: 45,
      name: "Louis Jones – Chartered Physiotherapist",
      profilePic: louis,
      review:
        "I have only been working with Jason a short time, approximately a month, and in 2 sessions with Jason, he has challenged some limiting beliefs I have about my business, which were really holding me back, and its completely transformed my confidence. In only 2 sessions I have implemented his valuable advice into action points, and have seen massive positive results in my cash flow and also a growth in business. Jason really pushes me to step outside of my comfort zone and become a better version of me, in order to grow and take my business where I want it to be. I will be recommending Jason to all business owners.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/elena-cornes-77b255160/",
      id: 46,
      name: "Elena Cornes – Elena’s Children’s Piano School",
      profilePic: elena,
      review:
        "When I moved to the UK from abroad I was a qualified school teacher and musician with 10 years experience. I really wanted to carry on my career in this country and so I sent my CV to some schools. The replies were that either they didn’t have a vacancy or that I could have a low paid position working along side their existing staff, or that I was overqualified for the position for which I was applying. I was determined to succeed and in my desperation I turned to Jason for help and advice to set up as a self-employed private piano teacher. I didn’t know where to get my new students from and a few piano teachers that I spoke to were not thriving. With Jason’s coaching and mentoring I realised that the sky was the limit and I could have as many students as I wanted. Within 18 months I had more than 35 regular pupils and a waiting list. Jason taught me how to set boundaries by drafting and applying Terms of Business and all aspects of running a small business successfully and efficiently. I’m very grateful to Jason as without him I would have considered changing my career. 50% of my success is due to Jason’s inspiration and confidence that I could do it. I highly recommend Jason Mentoring and Coaching for any difficulty or goal connected to Small Business. He helped me build my dream which is not only my work but my hobby and passion. What better situation to be in. He helped me enormously and he can help you too.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/taniapieri/",
      id: 47,
      name: "Tania Pieri – PA for Creatives",
      profilePic: tania,
      review:
        "Working with Jason is brilliant. It has given me financial security and flexibility with my time – two big priorities of mine. I went from having no business idea at all to reaching my 1st target income in just a few months. Jason is great at knowing just how much to nudge you forwards without being overwhelming. I am loving the challenges and joys of the business journey and look forward to seeing where I can take my ideas next…",
    },
    {
      linkedIn: "https://www.linkedin.com/in/richard-smith-03a9367a/",
      id: 48,
      name: "Richard Smith. Eyemasters Ltd",
      profilePic: richard,
      review:
        "I’ve run Corporate divisions historically, and have run my own business since 1995 – before the ubiquitous world wide web and even e mail – the rules of engagement have changed, and change we must reflect as individuals. As Ghandi once reflected, ‘You must be the change you want to see’ or something apposite like that. Our problem, in such a competitive world, is just how can we analyse, accept and handle the changing ways of doing business and yet retain the real reason why we went into business in the first place – we had the idea, the passion, the foresight, the skill and the overall desire. All this crowds our sensibilities, where do we go for advice and clarity? Jason will be frank, honest and perspective in analysing what you do, how you do it and more importantly, what you need to do to properly focus on what you want to achieve. Too many of us ‘enthusiasts’ confuse activity with accomplishment – Jason will provide that clarity to prioritize what you need to do, when you need to do it and hold you to it. Just spending money with a ‘coach’ is missing the point, Jason will ensure you participate, it’s your future after all, this guy is credible, he’s been there – to be recommended folks – have a conversation with him, he speaks with one tongue.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/calesinfield/",
      id: 49,
      name: "Cale Sinfield – Social Bee Social Media",
      profilePic: cale,
      review:
        "I have two successful businesses which are both taking off and I felt pulled in two directions, difficulty focusing on the growth of both, prioritising and using my time to maximum effect. I was also trying to ‘be strong’ and do everything myself when it was clear that I needed to delegate or outsource but I was unsure how. With these challenges in mind, I approached Jason to ask for his free discovery meeting to explain my situation and discuss his ‘Hidden Business Partner’ services. Having met with Jason it was obvious to me that he was someone I could trust and has excellent listening skills and considerable small business experience. I had spoken with some of his many existing clients at business networking events and read his online reviews and so decided to engage his services. Jason helps me to understand my personality better, why I prefer to do things in my business in the way that I do, highlighting my strengths and building my self-confidence. How to gain the strategic direction and support I need to move forward with my businesses. Jason is insightful and has the ability to look at a situation from many different angles. If I am feeling stuck he makes original suggestions, motivating me and creating momentum. In each and every session we agree on action points and he keeps me on track and holds me accountable. I suggest you meet Jason for a coffee. You won’t regret it. It’s not a quick fix, it is a journey together, so stick with it and he will help you to change your thoughts, behaviours and feelings and get the results in your small business you are looking for.",
    },
    {
      linkedIn: "https://www.linkedin.com/in/lee-courtney-15647483/",
      id: 50,
      name: "Lee Courtney. Prosper Home Loans Ltd.",
      profilePic: lee,
      review:
        "Jason is an exceptional business coach who can help any business owner take their business to the next level. Highly insightful, and having run successful businesses himself really understands the problems all small and medium business owners run into. Would highly recommend to anyone",
    },
    // {
    // 	linkedIn: "https://www.linkedin.com/in/susan-beckingham-a6407a1/",
    // 	id: 51,
    // 	name: "Susan Beckingham. Sussex Copywriting Ltd.",
    // 	profilePic: susan,
    // 	review:
    // 		"I highly recommend Jason as a business mentor and coach. He has the expertise you need to help you develop and grow your business – which, quite frankly, is what all of us need to do. Give him a call.",
    // },
    {
      showLinkedIn: "d-none",
      id: 52,
      name: "David Sinclair-Black. Sinclair Media Group Ltd.",
      profilePic: davidS,
      review:
        "I have been working with Jason during a very (personally) turbulent time in my business. Like many of his clients, I had a lack of focus, a lack of purpose with my work–and felt overwhelmed. What he helped most with, was his ability to get me to re-focus on what I had already done well, and to continue to do more of that. Specifically, to look at my reviews, pick out what my clients mentioned most about their enjoyment working with me, and continue to do provide what they enjoyed most. It sounds rather nonsensical that I wouldn't continue to do what they wanted, but I believe (and think what Jason helps his clients most with) is to get business owners to do what they already know they should do, but perhaps lack the awareness of doing. I wouldn't recommend any other business coach and look forward to continuing to work with Jason in the future.",
    },
  ];
  return (
    <div>
      {testimonialsList.map((testimonial) => (
        <HorizontalTestimonial
          profilePic={testimonial.profilePic}
          name={testimonial.name}
          review={testimonial.review}
          linkedIn={testimonial.linkedIn}
          showLinkedIn={testimonial.showLinkedIn || "d-block"}
        />
      ))}
    </div>
  );
};

export default TestimonialsList;
